import { SIPFrequencyData } from '../../types/mf-execution.types'
import { FrequencyType } from '../../types/calendar.types'

export const SIP_PREFERRED_DEFAULT_AMOUNT = 15000

export const getSIPDataByFrequency = (
  sipData: SIPFrequencyData[] | undefined,
  frequency: FrequencyType
): SIPFrequencyData | undefined => {
  if (!sipData) return undefined
  return sipData.find((data) => data.frequency === frequency)
}

export const getSIPMinAmount = (sipData: SIPFrequencyData[] | undefined, frequency: FrequencyType): number => {
  const frequencyData = getSIPDataByFrequency(sipData, frequency)
  return frequencyData?.minAmount ?? 0
}

export const getSIPMaxAmount = (sipData: SIPFrequencyData[] | undefined, frequency: FrequencyType): number => {
  const frequencyData = getSIPDataByFrequency(sipData, frequency)
  return frequencyData?.maxAmount ?? 0
}

export const getSIPDefaultAmount = (
  sipData: SIPFrequencyData[] | undefined,
  frequency: FrequencyType
): number => {
  const minAmount = getSIPMinAmount(sipData, frequency)
  const maxAmount = getSIPMaxAmount(sipData, frequency)
  if (
    SIP_PREFERRED_DEFAULT_AMOUNT >= minAmount &&
    SIP_PREFERRED_DEFAULT_AMOUNT <= maxAmount
  ) {
    return SIP_PREFERRED_DEFAULT_AMOUNT
  }
  return minAmount
}

export const getSIPStepper = (
  sipData: SIPFrequencyData[] | undefined,
  frequency: FrequencyType
): number | undefined => {
  const frequencyData = getSIPDataByFrequency(sipData, frequency)
  return frequencyData?.stepper
}

export const getSIPDayDetails = (sipData: SIPFrequencyData[] | undefined, frequency: FrequencyType): any[] => {
  const frequencyData = getSIPDataByFrequency(sipData, frequency)
  return frequencyData?.dayDetails ?? []
}

export const getAvailableMonthlyDays = (sipData: SIPFrequencyData[] | undefined): any[] => {
  return getSIPDayDetails(sipData, FrequencyType.MONTHLY)
}

export const getAvailableWeeklyDays = (sipData: SIPFrequencyData[] | undefined): any[] => {
  return getSIPDayDetails(sipData, FrequencyType.WEEKLY)
}

export const getAvailableDailyDays = (sipData: SIPFrequencyData[] | undefined): any[] => {
  return getSIPDayDetails(sipData, FrequencyType.DAILY)
}
